import P from 'helpers/predicates'

const JWT_TOKEN  = 'token'

const saveToken = (token) => localStorage.setItem(JWT_TOKEN, token)
const getToken = () => localStorage.getItem(JWT_TOKEN)
const removeToken = () => localStorage.removeItem(JWT_TOKEN)

const isAuthenticated = () => P.isNotNil(getToken())

export {
  isAuthenticated,
  saveToken,
  getToken,
  removeToken,
}
